module.exports = __webpack_public_path__ + "assets/media/hired-photo.86b90ceb.jpg";